import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['menu', 'button', 'iconClose', 'iconOpen']

  static values = {
    open: {type: Boolean, default: false},
  }

  initialize(event) {
  }

  toggle(e) {
    this.menuTarget.classList.toggle('tw-hidden')
    this.menuTarget.classList.toggle('tw-block')
    this.iconOpenTarget.classList.toggle('tw-hidden')
    this.iconOpenTarget.classList.toggle('tw-block')
    this.iconCloseTarget.classList.toggle('tw-hidden')
    this.iconCloseTarget.classList.toggle('tw-block')
  }
}
